import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AssetFilter } from '@unistocks/features/admin/components/asset-management/asset-filter';
import { SortOrder } from '@unistocks/proxy/axios-client';
import { MAX_RESULT_COUNT } from '@unistocks/shared/consts';
import { clone } from '@unistocks/shared/utils/util';

const defaultFilter: AssetFilter = {
  filter: '',
  assetType: [],
  dataSource: [],
  maxResultCount: MAX_RESULT_COUNT,
  page: 1,
  sorting: {
    prop: 'name',
    direction: SortOrder.Ascending
  }
};

export type AdminSlice = {
  assetFilter: AssetFilter;
};

const initialState: AdminSlice = {
  assetFilter: defaultFilter
};

const { reducer, actions, selectors, reducerPath } = createSlice({
  name: 'admin',
  reducerPath: 'admin',
  initialState,
  reducers: {
    setAssetFilter: (state, action: PayloadAction<AssetFilter | null>) => {
      state.assetFilter = action.payload ?? clone(defaultFilter);
    },

    clear: () => clone(initialState)
  },
  selectors: {
    selectAssetFilter: state => state.assetFilter
  }
});

export const AdminReducer = reducer;
export const AdminActions = actions;
export const AdminReducerPath = reducerPath;

export const { selectAssetFilter } = selectors;
